import { Box } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../components/Header";
import ImageInput from "../../../components/imageInput";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  getDesertsError,
  getDesertsStatus,
  getDesertsSuccess,
  updateStatus,
  getDesertsLoading,
  modifyDesert,
} from "../../../features/desertSlice";
import { useLocation, useNavigate } from "react-router-dom";
import TextFieldCompnent from "../../../components/textFieldComponent";
import RadioButtonComponent from "../../../components/radioButtonComponent";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import { getImageFormFields } from "../../../global/functions/imageHelper";
import ButtonComponent from "../../../components/ButtonComponent";
import { useTranslation } from "react-i18next";

const ModifyDesert = () => {
  const { t } = useTranslation();
  const { restaurantId } = useRestaurant();
  const location = useLocation();
  const data = location.state.desert;
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [previewImage, setPreviewImage] = useState(null);
  const dispatch = useDispatch();
  const status = useSelector(getDesertsStatus);
  const error = useSelector(getDesertsError);
  const loading = useSelector(getDesertsLoading);
  const success = useSelector(getDesertsSuccess);
  const navigate = useNavigate();

  const desertSchema = yup.object().shape({
    name: yup.string().required("Nom est requis"),
    price: yup
      .number()
      .required("Le prix est requis")
      .min(0, "La prix minimal est 0"),
    outOfStock: yup.boolean(),
    visible: yup.boolean(),
  });
  const initialValues = {
    name: data.name,
    price: data.price,
    outOfStock: data.outOfStock,
    visible: data.visible,
  };

  const handleFormSubmit = (values) => {
    const requestBody = {
      name: values.name,
      price: values.price,
      outOfStock: values.outOfStock,
      visible: values.visible,
      ...getImageFormFields(previewImage),
    };
    dispatch(
      modifyDesert({
        body: requestBody,
        desertId: data._id,
        restaurantId,
      })
    );
  };
  useEffect(() => {
    if (status === "modifySuccess") {
      toast.success(success);
      dispatch(updateStatus());
      navigate("/desert");
    } else if (status === "modifyError") {
      toast.error(error);
    }
  }, [status, error, dispatch, navigate, success]);

  return (
    <Box m="20px" className="main-application">
      <Header title={t("headers.editDessert")} subtitle={t("headers.editDessertSub")} />

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={desertSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="16px"
              gridTemplateColumns="repeat(6, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 6" },
              }}
            >
              <TextFieldCompnent
                type="text"
                label={t("fields.name")}
                change={handleChange}
                value={values.name}
                name="name"
                blur={handleBlur}
                touched={touched.name}
                error={errors.name}
                colum="span 3"
                row="1 / span 1"
                required
              />
              <TextFieldCompnent
                type="number"
                label={t("fields.price")}
                change={handleChange}
                value={values.price || 0}
                name="price"
                blur={handleBlur}
                touched={touched.price}
                error={errors.price}
                colum="span 3"
                row="2 / span 1"
                num={0}
                required
              />
              <RadioButtonComponent
                change={handleChange}
                colum="span 3"
                row="3 / span 1"
                name="outOfStock"
                radioText1={t("common.no")}
                radioText2={t("common.yes")}
                radioValue1={false}
                radioValue2={true}
                text={t("fields.outOfStock")}
                value={values.outOfStock}
              />
              <RadioButtonComponent
                change={handleChange}
                colum="span 3"
                row="4 / span 1"
                name="visible"
                radioText1={t("common.no")}
                radioText2={t("common.yes")}
                radioValue1={false}
                radioValue2={true}
                text={t("fields.showItem")}
                value={values.visible}
              />
              <ImageInput
                row="5 / span 1"
                previewImage={previewImage}
                setPreviewImage={setPreviewImage}
                image={data.image}
              />
            </Box>
            <ButtonComponent text={t("common.edit")} loading={loading} />
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default ModifyDesert;
